<template>
	<a target="_blank" :href="`https://wa.me/${phone}`">
		<img
			v-if="iconColor === 'Green'"
			class="place-self-end w-12 h-12 cursor-pointer"
			alt="WhatsAppGreenSquareButton"
			src="../../assets/images/WhatsApp-GreenSquare-Logo.wine.svg"
		/>
		<div v-else-if="iconColor === 'floating-whatsapp'" class="floating-whatsapp-button">
			<img class="w-10 h-10 cursor-pointer" alt="WhatsAppRoundedButton" src="../../assets/images/whatsapp.svg" />
		</div>
		<img
			v-else-if="iconColor === 'Gray'"
			class="place-self-end w-6 h-6 cursor-pointer"
			alt="WhatsAppButtonGraySquare"
			src="../../assets/images/whatsapp.svg"
		/>
		<img
			v-else
			class="place-self-end w-12 h-12 cursor-pointer"
			alt="WhatsAppButtonGraySquare"
			src="../../assets/images/WhatsApp-GraySquare-Logo.wine.svg"
		/>
	</a>
</template>

<script>
	export default {
		name: 'WhatsAppButton',
		props: {
			phone: {
				required: true,
				type: [String, Number],
			},
			iconColor: {
				type: String,
				default: 'Green',
			},
		},
	};
</script>

<style scoped>
	.floating-whatsapp-button {
		position: fixed;
		bottom: 50px;
		left: 20px;
		z-index: 1000;
		border-radius: 100px;
		border-color: rgba(0, 0, 0, 0);
		color: rgb(255, 255, 255);
		font-family: inherit;
		font-weight: bold;
		font-size: 0px;
		background-color: rgb(14, 193, 47);
		border-width: 0px;
		padding: 12px;

		box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
		transform: scale(1);
		animation: pulse 2s infinite;
	}

	@keyframes pulse {
		0% {
			transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);
		}

		70% {
			transform: scale(1);
			box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);
		}

		100% {
			transform: scale(0.95);
			box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);
		}
	}
</style>
